import { render, staticRenderFns } from "./classic.vue?vue&type=template&id=d5e23cc0&scoped=true&"
import script from "./classic.vue?vue&type=script&lang=js&"
export * from "./classic.vue?vue&type=script&lang=js&"
import style0 from "./classic.vue?vue&type=style&index=0&id=d5e23cc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e23cc0",
  null
  
)

export default component.exports